// @flow

import * as React from 'react';

import { useExtendedSuggestion } from 'src/DomainCreate/components/ProvidedArea/modules';
import { ExpirationDateBadge } from 'src/DomainRenew/components/ExpirationDateBadge';

import FqdnBadge from './FqdnBadge';

import styles from './BadgeList.scss';

type Props = {
  cheapRenew?: boolean,
  fqdn: string,
  premium?: number | boolean,
  expiresOn?: string,
};

function BadgeList({ cheapRenew, fqdn, premium, expiresOn }: Props) {
  const badgeTypes = [];

  // TODO: what to do for somehting else than domain create?
  const { hasDiscount } = useExtendedSuggestion({
    fqdn,
  });

  if (premium) badgeTypes.push('premium');
  if (cheapRenew) badgeTypes.push('cheap-renew');
  if (hasDiscount) badgeTypes.push('discount');

  const badges: Array<React$Element<any>> = badgeTypes
    .map(badgeType => (
      <FqdnBadge key={badgeType} type={badgeType} fqdn={fqdn} />
    ))
    .filter(Boolean);

  if (expiresOn)
    badges.push(<ExpirationDateBadge key="expiration" expiresOn={expiresOn} />);

  if (!badges.length) return null;

  return <div className={styles.badgeList}>{badges}</div>;
}

export default (React.memo<Props>(BadgeList): React.ComponentType<Props>);
